import { contracts } from '../../data/contracts'

export default {
	id: 1,
	name: 'OLAND - FOOD',
	deposit: '0',
	pair: {
		token0: {
			name: 'OLAND',
			symbol: 'OLAND',
			address: contracts[process.env.REACT_APP_NETWORK].olandAddress,
			logo: 'tokens/Oland.png'
		},
		token1: {
			name: 'FOOD',
			symbol: 'OFOOD',
			address: contracts[process.env.REACT_APP_NETWORK].foodAddress,
			logo: 'tokens/OFood.png'
		},
		address: contracts[process.env.REACT_APP_NETWORK].DEX.Pairs.OLAND_Food
	}
}
